export const getTime = (seconds: number) => {
  const m = Math.floor((seconds % 3600) / 60)
    .toString()
    .padStart(1, '0');
  const s = Math.floor(seconds % 60)
    .toString()
    .padStart(2, '0');

  return `${m}:${s}`;
};

export const convertToDateTimeFormat = (dateString: string): string => {
  if (!dateString) return '';

  const [year, month, day] = dateString.split('-');
  return [month, day, year].join('/');
};

// Convert Date to YYYY-MM-DD
export const convertDate = (date: Date) => {
  const year = date.getFullYear().toString();
  const month = (date.getMonth() + 1).toString();
  const day = date.getDate().toString();

  const mmChars = month.split('');
  const ddChars = day.split('');

  return year + '-' + (mmChars[1] ? month : '0' + mmChars[0]) + '-' + (ddChars[1] ? day : '0' + ddChars[0]);
};
